exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list[data-v-31845668]{padding:0 .2rem}.item[data-v-31845668]{padding:.3rem .12rem}img[data-v-31845668]{width:.34rem;height:.4rem}.itemContImg[data-v-31845668]{width:30%!important;height:auto!important;margin:.2rem auto;display:block}.itemCont[data-v-31845668]{background:#f9f9f9;padding:.2rem;margin-top:.22rem}.icon-shang[data-v-31845668]{color:#3d3d3d}.active[data-v-31845668]{-webkit-transform:rotate(180deg)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-31845668","scoped":true,"hasInlineConfig":false}!./node_modules/vux-loader/src/style-loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/my/direction/direction.vue
// module id = 305
// module chunks = 0